
import { useState, useCallback } from 'react';
import { type CrawlProgress } from '@/types/crawler';

export const crawlStages = [
  "Fetching sitemap...",
  "Processing URLs...",
  "Completing..."
];

export function useProgressTracking() {
  const [progress, setProgress] = useState<CrawlProgress>({ 
    progress: 0, 
    stage: crawlStages[0], 
    pagesProcessed: 0, 
    totalPages: 0 
  });

  const handleProgressUpdate = useCallback((progressData: CrawlProgress) => {
    setProgress(progressData);
  }, []);

  const updateStageByProgress = useCallback((currentProgress: number) => {
    let stage = crawlStages[0];
    
    if (currentProgress < 30) {
      stage = crawlStages[0];
    } else if (currentProgress < 90) {
      stage = crawlStages[1];
    } else {
      stage = crawlStages[2];
    }
    
    setProgress(prev => ({
      ...prev,
      stage,
      progress: currentProgress
    }));
  }, []);

  return {
    progress,
    handleProgressUpdate,
    updateStageByProgress,
    crawlStages
  };
}
